<template>
    <div>
      <div v-if="isPackage">
        <package-screen v-bind:isPackage="true"></package-screen>
        <package-list v-on:isShow="parentFn"></package-list>
      </div>
      <div v-show="isPackageDetail">
        <package-detail v-on:isPrepare="prepareFn" v-on:isPackList="backPackList" v-bind:packageTest="packageTest"></package-detail>
      </div>
      <div v-show="isPackagePrepare">
        <package-prepare v-on:isBack="isBack"></package-prepare>
      </div>
    </div>

</template>
<script>
import PackageScreen from '../PackageScreen/PackageScreen.vue'
import PackageList from '../PackageList/PackageList.vue';
import PackageDetail from '../PackageDetail/PackageDetail.vue';
import PackagePrepare from '../PackagePrepare/PackagePrepare.vue';

export default {
    name:'lessonPackage',
    props:{
      fromIndexPackageData:{
        type:Object,
        default:{
          isFromIndex:false
        }
      },
	  fromIndexResouresData:{
	    type:Object,
	    default:{'isFromIndexSyn':null,'subjectId':null,'routerMicroName':null}
	  }
    },
    created() {

    },
    data(){
        return{
          msgId:null,
          isPackageDetail:false,
          isPackage:true,
          isPackagePrepare:false,
          packageTest:null
        }
    },
    mounted(){
      let that = this;
      if(this.fromIndexPackageData.isFromIndex){
        this.isPackage = false;
        this.isPackageDetail = true;
        this.isPackagePrepare = false;
        this.fromIndexPackageData.isFromIndex = false;
        this.packageTest = {'packageId':this.fromIndexPackageData.packageId,'isPackage':true};
      }
      if(this.$route.query.id){
        this.isPackage = false;
        this.isPackageDetail = true;
        this.isPackagePrepare = false;
        this.fromIndexPackageData.isFromIndex = false;
        this.packageTest = {'packageId':this.$route.query.id,'isPackage':true};
      }
      this.$nextTick(()=>{
        $(document).scrollTop(0);
      })
    },
    methods:{
      parentFn(msg) {
        this.isPackageDetail = this.isPackage;
        this.isPackage = msg;
        // console.log(this.isPackage)
      },
      prepareFn(msg){
        this.isPackagePrepare = true;
        this.isPackageDetail = msg;
        this.isPackage = msg;
      },
      isBack(msg){
        this.isPackageDetail = true;
        this.isPackagePrepare = msg;
        this.isPackage = msg;
      },
      backPackList(msg){
       this.isPackage = true;
       this.isPackagePrepare = msg;
       this.isPackageDetail = msg;
      }
    },
    components:{PackageScreen,PackageList,PackageDetail,PackagePrepare}
}
</script>



// WEBPACK FOOTER //
// src/components/lessonPackage/lessonPackage.vue